import { render, staticRenderFns } from "./BanUsers.vue?vue&type=template&id=d80dd0c0&scoped=true"
import script from "./BanUsers.vue?vue&type=script&lang=js"
export * from "./BanUsers.vue?vue&type=script&lang=js"
import style0 from "./BanUsers.vue?vue&type=style&index=0&id=d80dd0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80dd0c0",
  null
  
)

export default component.exports